import React from 'react'
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { CreateJobPositionFormTrainComponent } from '../../components/Officer/CreateJobPositionFormTrainComponent'
import { Footer } from "../../components/share/Footer";

export const CreateJobPositionFormTrainContainer = () => {
  const titleName =
      "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการฝึกอบรม";
  
    return (
      <div className="page-container bg-landing">
        <NavbarBorrowSystem />
        <HeadTitle title={titleName} />
        <CreateJobPositionFormTrainComponent />
        <Footer />
      </div>
    );
  
}
